import SeedAudiencesTable from './SeedAudiencesTable.Container';

export default SeedAudiencesTable;
